import React from 'react'

const Daycare = () => {
  return (
    <div className='mx-auto p-4'>
      Daycare
    </div>
  )
}

export default Daycare
